import { render, staticRenderFns } from "./addtocatalog.vue?vue&type=template&id=72e9b4bd&scoped=true&"
import script from "./addtocatalog.vue?vue&type=script&lang=js&"
export * from "./addtocatalog.vue?vue&type=script&lang=js&"
import style0 from "./addtocatalog.vue?vue&type=style&index=0&id=72e9b4bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e9b4bd",
  null
  
)

export default component.exports